// CountrySelect.js
import React, { useEffect, useState } from "react";
import Select from "react-select";
import axios from "axios";

const CountrySelect = ({
  value,
  onChange = () => {},
  placeholder = "Enter country",
}) => {
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchCountries = async () => {
      setLoading(true);
      const token = localStorage.getItem("token");

      if (!token) {
        alert("Session expired or missing. Please login again.");
        setLoading(false);
        return;
      }

      try {
        const response = await axios.get(
          "https://eventscons.com/eventbackendnew/api/countries",
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        const data = response.data?.data;

        if (!Array.isArray(data)) {
          alert("Invalid response from server.");
          setCountries([]);
          return;
        }

        setCountries(data);
      } catch (error) {
        console.error("Country API Error:", error);
        alert("Error fetching countries: " + (error.message || "Unknown error"));
        setCountries([]);
      } finally {
        setLoading(false);
      }
    };

    fetchCountries();
  }, []);

  const options = countries.map((c) => ({
    value: c.name,
    label: (
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <img
          src={c.flag_url}
          alt={`${c.name} flag`}
          style={{ width: 24, height: 16, objectFit: "cover" }}
        />
        <span>{c.name}</span>
      </div>
    ),
  }));

  const selectedOption = options.find((opt) => opt.value === value) || null;

  return (
    <Select
      options={options}
      value={selectedOption}
      onChange={(selected) =>
        onChange(selected ? selected.value : "")
      }
      placeholder={placeholder}
      isClearable
      isLoading={loading}
      styles={{
        container: (provided) => ({ ...provided, width: "100%" }),
        menu: (provided) => ({ ...provided, zIndex: 9999 }),
      }}
    />
  );
};

export default CountrySelect;